import { render, staticRenderFns } from "./PageMain.vue?vue&type=template&id=7ed64216&scoped=true&"
import script from "./PageMain.vue?vue&type=script&lang=js&"
export * from "./PageMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed64216",
  null
  
)

export default component.exports